import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Tabs.svg",
  "use": "Tabs.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Tabs.svg\"><path d=\"M50.01,44.0208h-6v6a6,6,0,0,1-6,6h-24a6,6,0,0,1-6-6v-24a6,6,0,0,1,6-6h6v-6a6,6,0,0,1,6-6h24a6,6,0,0,1,6,6v24A6,6,0,0,1,50.01,44.0208Zm-10-18a2,2,0,0,0-2-2h-24a2,2,0,0,0-2,2v24a2,2,0,0,0,2,2h24a2,2,0,0,0,2-2Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol